import { render, staticRenderFns } from "./ReleaseProcessDlg.vue?vue&type=template&id=b83d55a6&scoped=true&"
import script from "./ReleaseProcessDlg.vue?vue&type=script&lang=ts&"
export * from "./ReleaseProcessDlg.vue?vue&type=script&lang=ts&"
import style0 from "./ReleaseProcessDlg.vue?vue&type=style&index=0&id=b83d55a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83d55a6",
  null
  
)

export default component.exports